module.exports = __webpack_public_path__ + "img/nogroupsend.226cf07c.svg";